export const steps = ['min', 'mid', 'max', 'custom'];

const baseOptions = [
    {
        title: 'storageType',
        values: [
            {
                value: 'compute',
                label: 'Compute disk'
            },
            {
                value: 'storage',
                label: 'Storage Service'
            }
        ]
    },
    {
        title: 'space',
        type: 'range'
    },
    {
        title: 'usable',
    }
];

export const getServices = (t) => [
    {
        title: 'compute',
        img: '/configurator/compute.svg',
        isMain: true,
        summary: true,
        conf: true,
        options: [
            {
                title: 'computeNodes',
                summaryTitle: 'physicalNode',
                values: [
                    {
                        value: 3,
                        label: '3'
                    },
                    {
                        value: 5,
                        label: '5'
                    },
                    {
                        value: 7,
                        label: '7'
                    },
                    {
                        value: 9,
                        label: '9'
                    },
                    {
                        value: 11,
                        label: '11'
                    },
                    {
                        value: 13,
                        label: '13'
                    },
                    {
                        value: 15,
                        label: '15'
                    }
                ],
                min: 3,
                mid: 5,
                max: 15
            },
            {
                title: 'cpu',
                summaryTitle: 'cpu',
                values: [
                    {
                        value: 12,
                        label: '1x12 Cores'
                    },
                    {
                        value: 24,
                        label: '2x12 Cores'
                    },
                    {
                        value: 40,
                        label: '2x20 Cores'
                    },
                    {
                        value: 56,
                        label: '2x28 Cores'
                    },
                    {
                        value: 72,
                        label: '4x18 Cores'
                    },
                    {
                        value: 96,
                        label: '4x24 Cores'
                    },
                    {
                        value: 144,
                        label: '4x36 Cores'
                    }
                ],
                min: 12,
                mid: 40,
                max: 144
            },
            {
                title: 'ram',
                summaryTitle: 'ram',
                values: [
                    {
                        value: 128,
                        label: `128 ${t("gib")}`
                    },
                    {
                        value: 256,
                        label: `256 ${t("gib")}`
                    },
                    {
                        value: 512,
                        label: `512 ${t("gib")}`
                    },
                    {
                        value: 768,
                        label: `768 ${t("gib")}`
                    },
                    {
                        value: 1000,
                        label: `1 ${t("tib")}`
                    },
                    {
                        value: 1500,
                        label: `1.5 ${t("tib")}`
                    }
                ],
                min: 128,
                mid: 768,
                max: 1500
            },
            {
                summaryTitle: 'disk',
                values: [
                    {
                        value: '256',
                        label: `1x256 ${t("gib")}`
                    },
                    {
                        value: '512',
                        label: `1x512 ${t("gib")}`
                    },
                    {
                        value: '1024',
                        label: `1x1024 ${t("gib")}`
                    }
                ],
                min: '256',
                mid: '512',
                max: '1024'
            },
            {
                title: 'gpu',
                summaryTitle: 'gpu',
                values: [
                    {
                        value: 0,
                        label: 'None'
                    },
                    {
                        value: 16,
                        label: `1x16 ${t("gib")}`
                    },
                    {
                        value: 32,
                        label: `1x32 ${t("gib")}`
                    },
                    {
                        value: 64,
                        label: `2x32 ${t("gib")}`
                    }
                ],
                min: 0,
                mid: 32,
                max: 64
            }
        ]
    },
    {
        title: 'equipment',
        noDescription: true,
        isMain: true,
        conf: true,
    },
    {
        title: 'networking',
        img: '/configurator/networking.svg',
        isMain: true,
        conf: true,
        options: [
            {
                title: 'isAnonymus',
                summaryTitle: 'isAnonymusSummary',
                min: false,
                mid: true,
                max: true
            },
            {
                title: 'ipv4',
                summaryTitle: 'ipv4Summary',
                values: [
                    {
                        value: '/28',
                        label: '/28'
                    },
                    {
                        value: '/24',
                        label: '/24'
                    },
                    {
                        value: '/22',
                        label: '/22'
                    }
                ],
                min: '/28',
                mid: '/24',
                max: '/22'
            },
            {
                title: 'bandwidth',
                values: [
                    {
                        value: '100 Mbps',
                        label: '100 Mbps'
                    },
                    {
                        value: '500 Mbps',
                        label: '500 Mbps'
                    },
                    {
                        value: '1Gbps',
                        label: '1Gbps'
                    }
                ],
                min: '100 Mbps',
                mid: '500 Mbps',
                max: '1Gbps'
            },
            {
                summaryTitle: 'dataSwitch'
            },
            {
                summaryTitle: 'cables'
            },
            {
                summaryTitle: 'managementSwitch'
            },
            {
                summaryTitle: 'patchCable'
            }
        ]
    },
    {
        isMain: true,
        title: 'storage',
        img: '/configurator/storage.svg',
        summary: true,
        conf: true,
        externalValues: [
            {
                value: 1024,
                label: `1 ${t("tib")}`
            },
            {
                value: 5120,
                label: `5 ${t("tib")}`
            },
            {
                value: 10240,
                label: `10 ${t("tib")}`
            },
            {
                value: 20480,
                label: `20 ${t("tib")}`
            },
            {
                value: 51200,
                label: `50 ${t("tib")}`
            },
            {
                value: 102400,
                label: `100 ${t("tib")}`
            },
            {
                value: 204800,
                label: `200 ${t("tib")}`
            },
            {
                value: 512000,
                label: `500 ${t("tib")}`
            },
            {
                value: 1024000,
                label: `1000 ${t("tib")}`
            }
        ],
        options: [
            {
                title: 'type',
                min: 1,
                mid: 2,
                max: 3
            },
            {
                title: 'nodes',
                min: 3,
                mid: 5,
                max: 15
            },
            {
                title: 'size',
                min: 1024,
                mid: 20480,
                max: 102400
            }
        ]
    },
    {
        title: 'code',
        img: '/configurator/code.svg',
        isMain: false,
        conf: true,
        options: baseOptions
    },
    {
        title: 'disk',
        img: '/configurator/disk.svg',
        isMain: false,
        conf: true,
        options: [
            {
                title: 'users',
                values: [
                    {
                        value: 10,
                        label: '10'
                    },
                    {
                        value: 100,
                        label: '100'
                    },
                    {
                        value: 500,
                        label: '500'
                    },
                    {
                        value: 1000,
                        label: '1000'
                    },
                    {
                        value: 5000,
                        label: '5000'
                    }
                ]
            },
            ...baseOptions
        ]
    },
    {
        title: 'artifactory',
        img: '/configurator/artifactory.svg',
        isMain: false,
        conf: true,
        options: baseOptions
    },
    {
        title: 'openshift',
        img: '/configurator/outrun.svg',
        isMain: false,
        conf: true,
        options: [
            {
                title: 'nodes',
                values: [
                    {
                        value: 3,
                        label: '3'
                    },
                    {
                        value: 5,
                        label: '5'
                    },
                    {
                        value: 10,
                        label: '10'
                    },
                    {
                        value: 15,
                        label: '15'
                    }
                ],
                min: 3,
                mid: 5,
                max: 15
            },
            {
                title: 'ram',
                values: [
                    {
                        value: 32,
                        label: `32 ${t("gib")}`
                    },
                    {
                        value: 64,
                        label: `64 ${t("gib")}`
                    },
                    {
                        value: 96,
                        label: `96 ${t("gib")}`
                    },
                    {
                        value: 128,
                        label: `128 ${t("gib")}`
                    }
                ],
                min: 32,
                mid: 64,
                max: 128
            },
            {
                title: 'cpu',
                values: [
                    {
                        value: 8,
                        label: '8'
                    },
                    {
                        value: 12,
                        label: '12'
                    },
                    {
                        value: 16,
                        label: '16'
                    },
                    {
                        value: 24,
                        label: '24'
                    },
                    {
                        value: 32,
                        label: '32'
                    },
                    {
                        value: 40,
                        label: '40'
                    }
                ],
                min: 8,
                mid: 24,
                max: 40
            }
        ]
    },
    {
        title: 'power',
        summary: true,
        conf: false,
        options: [
            {
                summaryTitle: 'pdu',
            },
            {
                summaryTitle: 'kva',
            }
        ]
    },
    {
        title: 'units',
        summary: true,
        conf: false,
        options: [
            {
                summaryTitle: 'quantity',
            }
        ]
    },
    {
        storageConfigs: {
            type: {
                values: [
                    {
                        value: 1,
                        label: 'SSD only'
                    },
                    {
                        value: 2,
                        label: 'SSD + HDD combined'
                    },
                    {
                        value: 3,
                        label: 'SSD and HDD'
                    }
                ]
            },
            nodes: {
                values: [
                    {
                        value: 3,
                        label: '3'
                    },
                    {
                        value: 5,
                        label: '5'
                    },
                    {
                        value: 9,
                        label: '9'
                    },
                    {
                        value: 15,
                        label: '15'
                    }
                ]
            },
            size: {
                values: [
                    {
                        value: 1024,
                        label: `1 ${t("tib")}`
                    },
                    {
                        value: 10240,
                        label: `10 ${t("tib")}`
                    },
                    {
                        value: 20480,
                        label: `20 ${t("tib")}`
                    },
                    {
                        value: 51200,
                        label: `50 ${t("tib")}`
                    },
                    {
                        value: 102400,
                        label: `100 ${t("tib")}`
                    }
                ]
            },
            externalValues: [
                {
                    value: 1024,
                    label: `1 ${t("tib")}`
                },
                {
                    value: 5120,
                    label: `5 ${t("tib")}`
                },
                {
                    value: 10240,
                    label: `10 ${t("tib")}`
                },
                {
                    value: 20480,
                    label: `20 ${t("tib")}`
                },
                {
                    value: 51200,
                    label: `50 ${t("tib")}`
                },
                {
                    value: 102400,
                    label: `100 ${t("tib")}`
                },
                {
                    value: 204800,
                    label: `200 ${t("tib")}`
                },
                {
                    value: 512000,
                    label: `500 ${t("tib")}`
                },
                {
                    value: 1024000,
                    label: `1000 ${t("tib")}`
                }
            ]
        },
        computesConfig: {
            computeNodes: [
                {
                    value: 3,
                    label: '3'
                },
                {
                    value: 5,
                    label: '5'
                },
                {
                    value: 7,
                    label: '7'
                },
                {
                    value: 9,
                    label: '9'
                },
                {
                    value: 11,
                    label: '11'
                },
                {
                    value: 13,
                    label: '13'
                },
                {
                    value: 15,
                    label: '15'
                }
            ],
            cpu: [
                {
                    value: 12,
                    label: '1x12 Cores'
                },
                {
                    value: 24,
                    label: '2x12 Cores'
                },
                {
                    value: 40,
                    label: '2x20 Cores'
                },
                {
                    value: 56,
                    label: '2x28 Cores'
                },
                {
                    value: 72,
                    label: '4x18 Cores'
                },
                {
                    value: 96,
                    label: '2x24 Cores'
                },
                {
                    value: 144,
                    label: '4x36 Cores'
                }
            ],
            ram: [
                {
                    value: 128,
                    label: `128 ${t("gib")}`
                },
                {
                    value: 256,
                    label: `256 ${t("gib")}`
                },
                {
                    value: 512,
                    label: `512 ${t("gib")}`
                },
                {
                    value: 768,
                    label: `768 ${t("gib")}`
                },
                {
                    value: 1000,
                    label: `1 ${t("tib")}`
                },
                {
                    value: 1500,
                    label: `1.5 ${t("tib")}`
                }
            ],
            disk: [
                {
                    value: '256',
                    label: `1x256 ${t("gib")}`
                },
                {
                    value: '512',
                    label: `1x512 ${t("gib")}`
                },
                {
                    value: '1024',
                    label: `1x1024 ${t("gib")}`
                }
            ],
            gpu: [
                {
                    value: 0,
                    label: 'None'
                },
                {
                    value: 16,
                    label: `1x16 ${t("gib")}`
                },
                {
                    value: 32,
                    label: `1x32 ${t("gib")}`
                },
                {
                    value: 64,
                    label: `2x32 ${t("gib")}`
                }
            ]
        },
        disks: ['ssd', 'hdd'],
        storageParams: ['nodes', 'size', 'usable'],
        computeParams: ['computeNodes', 'ram', 'cpu', 'gpu']
    }
];

export const addServices = [
    { name: 'Compliance', description: 'complianceDescription', img: '/configurator/compliance.svg' }
];

export const prices = {
    basic: {
        cpu: 2.500,
        ram: 0.1250,
        storage: 0.0150,
        gpu: 4.7500
    },
    standart: {
        cpu: 3.1250,
        ram: 0.1563,
        storage: 0.0188,
        gpu: 5.9375
    }
};

export const summary = {
    compute: {
        node: 'Physical Nodes (Qty.)',
        cpu: 'CPU',
        ram: 'RAM',
        storage: 'Disk'
    },
    storage: {
        node: 'Physical Nodes (Qty.)',
        cpu: 'CPU',
        ram: 'RAM',
        storage: 'Disk'
    },
    networking: {
        isAnonymus: 'Autonomous System',
        ipv4: 'Public IP Addresses',
        bandwidth: '',
        dataSwitch: 'Data Switch (25GbE)',
        cables: 'Direct-Attached Copper Cables',
        manageSwitch: 'Management Switch (1GbE)',
        patchCable: 'Patch Cable'
    },
    power: {
        pdu: 'PDU (<спецификация PDU>)',
        kva: 'KVA'
    },
    units: {
        quantity: 'Quantity'
    }
};
